export default __webpack_public_path__ + "static/media/case4.5c352717.jpg";